import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { deepClone, XcHelpPart } from '@gspwidget/util';
import { uniq }  from 'lodash-es';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/core/tree/public-api';

@Component({
  selector: 'xc-help-shell',
  templateUrl: './help-shell.component.html',
  styleUrls: ['./help-shell.component.scss']
})
export class XcHelpShellComponent implements OnInit {

  /** ä»åæ¬¡ææ */
  @Input() parts: XcHelpPart[]
  @Input() onSelect: (result: any) => void

  firstSelected = null
  innerParts: XcHelpPart[]

  constructor (
    public http: HttpClient,
    public cd: ChangeDetectorRef,
  ) { }


  ngOnInit () {
    // this.innerParts = deepClone(this.parts)
    this.innerParts = this.parts
    // æ¸ç©ºåç«¯ä¿®æ¹ï¼ä»¥é²åå°ä¸æ¬¡æå¼æ­¤ part æ¶è¿äºä¿®æ¹çå½±åãæ²¡ deepClone çåå æ¯ï¼ç°å¨ç clone ä¸ä¼å¤å¶æ¹æ³ã
    // TODO: èèåç»­å¢å å¯ä»¥å¤å¶æ¹æ³ç deepClone.
    this.innerParts.forEach(part => {
      part._data = null
      part._selectedItem = null
      part._loading = null
    })
    if (!this.innerParts[0]) return
    const getData$ = this.parts[0].xcGetData({ http: this.http })
    if (!getData$) return
    this.innerParts[0]._loading = true
    if (getData$.subscribe) getData$.subscribe(res => {
      res = deepClone(res)
      this.innerParts[0]._loading = false
      this.innerParts[0]._data = res
    })
    if (getData$.then) getData$.then(res => {
      res = deepClone(res)
      this.innerParts[0]._loading = false
      this.innerParts[0]._data = res
    })
  }
  getResult () {
    if (!this.innerParts || !this.innerParts[0]) throw new Error('xc: no parts.')
    const { _selectedItem } = this.innerParts[this.innerParts.length - 1]
    return Array.isArray(_selectedItem) ? _selectedItem.slice() : _selectedItem
  }
  isValid (): boolean {
    return !!this.innerParts[this.innerParts.length - 1]._selectedItem
  }

  handleClickItem (item, part: XcHelpPart, i: number) {
    part._selectedItem = item
    if (i !== this.innerParts.length - 1) {
      const getData$ = this.innerParts[i + 1].xcGetData({
        http: this.http,
        parent: item,
      })
      if (getData$.subscribe) getData$.subscribe(res => {
        this.innerParts[i + 1]._data = res
      })
      if (getData$.then) getData$.then(res => {
        this.innerParts[i + 1]._data = res
      })
    }
    // åé¢çé½ç½®ç©º
    this.innerParts.forEach((iPart, ii) => {
      if (ii > i) {
        iPart._selectedItem = null
      }
      if (ii > i + 1) {
        iPart._data = []
      }
    })
  }
  handleDbClickItem (item, part: XcHelpPart, i: number) {
    if (i === this.innerParts.length - 1) {
      if (this.onSelect) this.onSelect(item)
    }
  }

  handleClickTreeNode (e: NzFormatEmitEvent, part: XcHelpPart, i: number) {
    this.handleClickItem(e.node.origin, part, i)
    console.log(e)
  }
  handleDbClickTreeNode (e: NzFormatEmitEvent, part: XcHelpPart, i: number) {
    this.handleDbClickItem(e.node.origin, part, i)
    console.log(e)
  }

  handleMultiTreeCheckChange (e: NzFormatEmitEvent, part: XcHelpPart, i: number) {
    console.log(e)
    /** å®ééä¸­ç nzTreeNode é¡¹ï¼åé¢çç»æå¤çé½åºäºå®ï¼å¯ä»¥è¢«éç½®ä¸­ç resultProcess æ¹åã */
    let selectedNodes = e.checkedKeys

    if (part.xcMultiTreeOption && part.xcMultiTreeOption.processSelectedNodes) {
      selectedNodes = part.xcMultiTreeOption.processSelectedNodes(selectedNodes)
    }

    // TODO: è¿ä¸ªè· leavesOnly å¥åºå« ?
    if (this.getMultiTreeResult(part) === 'default') {
      part._selectedItem = selectedNodes.map(checkedNode => checkedNode.origin)
      console.log('selected items', part._selectedItem)
    } else if (part.xcMultiTreeOption.result === 'withParentsChildren') {
      const checkedNodes = [...selectedNodes]
      selectedNodes.forEach(node => {
        addParentRecur(node.parentNode, checkedNodes)
        addChildrenRecur(node.children, checkedNodes)
      })
      part._selectedItem = uniq(checkedNodes).map(checkedNode => checkedNode.origin)
      this.cd.markForCheck()

    } else if (part.xcMultiTreeOption.result === 'leavesOnly') {
      // TODO: å¾å®ç°
    }

    console.log(part._selectedItem)
  }

  getMultiTreeResult (part: XcHelpPart) {
    if (!part.xcMultiTreeOption || !part.xcMultiTreeOption.result
      || part.xcMultiTreeOption.result === 'default') return 'default'
    return part.xcMultiTreeOption.result
  }

  getLastPart () {
    return this.innerParts && this.innerParts[0] && this.innerParts[this.innerParts.length-1]
  }

  drop(event: CdkDragDrop<string[]>, list: XcHelpPart[]) {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
  }
}

function addParentRecur (originNode: NzTreeNode, targetList: NzTreeNode[]) {
  if (!originNode) return
  targetList.push(originNode)
  addParentRecur(originNode.parentNode, targetList)
}

function addChildrenRecur (originNodes: NzTreeNode[], targetList: NzTreeNode[]) {
  if (!originNodes) return
  targetList.push(...originNodes)
  originNodes.forEach(node => {
    addChildrenRecur(node.children, targetList)
  })
}
